/* ── ПРЕВКЛЮЧВАНЕ НА ТАБОВЕ ── */
/* ── ТЪРСАЧКА И ФИЛТЪР ── */

document.addEventListener('DOMContentLoaded', () => {

  /* Табове */
  const tabs    = document.querySelectorAll('.ds-tab');
  const panels  = document.querySelectorAll('.ds-panel');
  const tabsBar = document.getElementById('dsTabs');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      document.getElementById('tab-' + tab.dataset.tab).classList.add('active');

      /* Скролване до търсачката */
      const searchWrap = document.querySelector('.ds-search-wrap');
      window.scrollTo({ top: searchWrap.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    });
  });

  /* Търсачка */
  const search     = document.getElementById('dsSearch');
  const page       = document.getElementById('dsPage');
  const noResults  = document.getElementById('dsNoResults');
  const searchTerm = document.getElementById('dsSearchTerm');

  search.addEventListener('input', () => {
    const q = search.value.trim().toLowerCase();

    if (!q) {
      page.classList.remove('searching', 'no-results');
      panels.forEach(p => p.style.display = '');
      document.querySelectorAll('.ds-table tbody tr').forEach(r => r.classList.remove('hidden'));
      return;
    }

    page.classList.add('searching');
    let found = 0;

    /* Показване/скриване на редове */
    document.querySelectorAll('.ds-table tbody tr').forEach(row => {
      if (row.classList.contains('ds-section-row')) { row.classList.add('hidden'); return; }
      const match = row.textContent.toLowerCase().includes(q);
      row.classList.toggle('hidden', !match);
      if (match) found++;
    });

    /* Показване на секционни заглавия само ако имат видими редове */
    document.querySelectorAll('.ds-table tbody tr.ds-section-row').forEach(header => {
      let next = header.nextElementSibling;
      let show = false;
      while (next && !next.classList.contains('ds-section-row')) {
        if (!next.classList.contains('hidden')) { show = true; break; }
        next = next.nextElementSibling;
      }
      header.classList.toggle('hidden', !show);
    });

    /* Скриване на панели без резултати */
    panels.forEach(panel => {
      const visible = panel.querySelectorAll('tbody tr:not(.ds-section-row):not(.hidden)').length;
      panel.style.display = visible ? 'block' : 'none';
    });

    /* Съобщение при нулев резултат */
    page.classList.toggle('no-results', found === 0);
    if (found === 0) searchTerm.textContent = search.value.trim();
  });

});